const PASSIVO_TIPO = {
    EMP: { id: 'EMP', sigla: 'PESSOAL', descricao: 'Empréstimo Pessoal', mercado: 'EMP', prazo: 'FIN' },
    EMPG: { id: 'EMPG', sigla: 'GARANTIDA', descricao: 'Empréstimo - Conta Garantida', mercado: 'EMP', prazo: 'ROT' },
    EMPP: { id: 'EMPP', sigla: 'PENHOR', descricao: 'Empréstimo por Penhor', mercado: 'EMP', prazo: 'ROT' },
    EMPE: { id: 'EMPE', sigla: 'ESPECIAL', descricao: 'Cheque Especial', mercado: 'EMP', prazo: 'ROT' },
    EMPT: { id: 'EMPT', sigla: 'CARTAO', descricao: 'Cartão de Crédito', mercado: 'EMP', prazo: 'ROT' },
    EMPI: { id: 'EMPI', sigla: 'CONSIGNADO', descricao: 'Empréstimo Consignado', mercado: 'EMP', prazo: 'CIG' },

    IMVP: { id: 'IMVP', sigla: 'IMVP', descricao: 'Imóvel - Financiamento', mercado: 'IMV', prazo: 'FIN' },
    IMVL: { id: 'IMVL', sigla: 'IMVL', descricao: 'Imóvel - Leasing', mercado: 'IMV', prazo: 'LEA' },
    IMVC: { id: 'IMVC', sigla: 'IMVC', descricao: 'Imóvel - Consórcio', mercado: 'IMV', prazo: 'COR' },

    VEIP: { id: 'VEIP', sigla: 'VEIP', descricao: 'Veículo - Financiamento', mercado: 'VEI', prazo: 'FIN' },
    VEIL: { id: 'VEIL', sigla: 'VEIL', descricao: 'Veículo - Leasing', mercado: 'VEI', prazo: 'LEA' },
    VEIC: { id: 'VEIC', sigla: 'VEIC', descricao: 'Veículo - Consórcio', mercado: 'VEI', prazo: 'COR' },

    BEMP: { id: 'BEMP', sigla: 'BEMP', descricao: 'Bem - Financiamento', mercado: 'BEM', prazo: 'FIN' },
    BEML: { id: 'BEML', sigla: 'BEML', descricao: 'Bem - Leasing', mercado: 'BEM', prazo: 'LEA' },
    BEMC: { id: 'BEMC', sigla: 'BEMC', descricao: 'Bem - Consórcio', mercado: 'BEM', prazo: 'COR' },

    SGRS: { id: 'SGRS', sigla: 'SAÚDE', descricao: 'Seguro de Saúde', mercado: 'SGR', prazo: 'VST' },
    // SGRP: { id: 'SGRP', sigla: 'PREVIDÊNCIA', descricao: 'Seguro de Previdência', mercado: 'SGR', prazo: 'VST' },
    SGRD: { id: 'SGRD', sigla: 'VIDA', descricao: 'Seguro de Vida', mercado: 'SGR', prazo: 'VST' },
    SGRI: { id: 'SGRI', sigla: 'IMÓVEL', descricao: 'Seguro de Imóvel', mercado: 'SGR', prazo: 'VST' },
    SGRV: { id: 'SGRV', sigla: 'AUTO', descricao: 'Seguro de Veículo', mercado: 'SGR', prazo: 'VST' },
    SGRB: { id: 'SGRB', sigla: 'BEM', descricao: 'Seguro de Bem', mercado: 'SGR', prazo: 'VST' }
};

module.exports = PASSIVO_TIPO;
